import styled from "styled-components";

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: calc(100vh - 48px);
  overflow: hidden;
  padding-block-start: 24px;
`;

export const OverviewContent = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr 0.6fr;
  width: 100%;
  max-width: 1400px;
  height: 100%;
  h1 {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 16px 0;
  }

  p {
    font-size: 16px;
    color: ${(props) => props.theme.colors.davysGrey};
    margin: 0;
  }
`; 